import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { PasswordCaptureFields } from '../../types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface LayoutTabProps {
  form: UseFormReturn<PasswordCaptureFields>;
}

export function LayoutTab({ form }: LayoutTabProps) {
  useLanguage();
  return (
    <div className="space-y-6">
      {/* Card: Título */}
      <Card className="bg-white border border-[#E2E8F0] rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.02)]">
        <CardHeader className="pb-4">
          <CardTitle className="text-[17px] font-semibold text-[#101828]">{translateInterfaceText("Título")}</CardTitle>
          <CardDescription className="text-[13px] text-[#667085]">
            {translateInterfaceText("Texto principal do formulário")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label htmlFor="headline">{translateInterfaceText("Título do formulário")}</Label>
            <Input
              id="headline"
              value={form.watch('content.title.text')}
              onChange={(e) =>
                form.setValue('content.title.text', e.target.value, { shouldDirty: true })
              }
              placeholder={translateInterfaceText("Ex: Libere o acesso ao vídeo")}
              className="mt-2"
            />
          </div>
        </CardContent>
      </Card>

      {/* Card: Senha de Acesso */}
      <Card className="bg-white border border-[#E2E8F0] rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.02)]">
        <CardHeader className="pb-4">
          <CardTitle className="text-[17px] font-semibold text-[#101828]">{translateInterfaceText("Senha de Acesso")}</CardTitle>
          <CardDescription className="text-[13px] text-[#667085]">
            {translateInterfaceText("Defina a senha que o usuário precisará digitar para acessar o vídeo")}</CardDescription>
        </CardHeader>
        <CardContent>
          <div>
            <Label htmlFor="password-value">{translateInterfaceText("Senha *")}</Label>
            <Input
              id="password-value"
              type="text"
              value={form.watch('content.password.value')}
              onChange={(e) =>
                form.setValue('content.password.value', e.target.value, { shouldDirty: true })
              }
              placeholder={translateInterfaceText("Digite a senha de acesso")}
              className="mt-2"
            />
            <p className="text-[12px] text-[#6B7280] mt-2">
              {translateInterfaceText("Esta será a senha que os usuários precisarão digitar para desbloquear o vídeo")}</p>
          </div>
        </CardContent>
      </Card>

      {/* Card: Botão */}
      <Card className="bg-white border border-[#E2E8F0] rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.02)]">
        <CardHeader className="pb-4">
          <CardTitle className="text-[17px] font-semibold text-[#101828]">{translateInterfaceText("Botão")}</CardTitle>
          <CardDescription className="text-[13px] text-[#667085]">
            {translateInterfaceText("Configure os textos do botão de ação")}</CardDescription>
        </CardHeader>
        <CardContent>
          <div>
            <Label htmlFor="button-text">{translateInterfaceText("Texto do botão principal")}</Label>
            <Input
              id="button-text"
              value={form.watch('content.button_label')}
              onChange={(e) =>
                form.setValue('content.button_label', e.target.value, { shouldDirty: true })
              }
              placeholder={translateInterfaceText("Ex: Continuar Assistindo")}
              maxLength={10}
              className="mt-2"
            />
            <p className="text-[12px] text-[#6B7280] mt-1">
              {translateInterfaceText("Máximo de 10 caracteres")}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
